import React from 'react';

import { aiMessages } from '@atlaskit/editor-common/ai-messages/ai';
import { aiConfigItemMessages } from '@atlaskit/editor-common/ai-messages/ai-config-items';

import { SummarizeIcon } from '../../../../icons/prompt/summarize';
import {
	createInsertAtCurrentPosition,
	createInsertBelow,
	createReplace,
} from '../../actions/create-actions';
import { CONFIG_ITEM_KEYS } from '../../config-item-keys';
import type {
	EditorPluginAIConfigItemFactory,
	EditorPluginAIConfigItemWithOptionsFactory,
} from '../../config-items';

export const summarizeWriting: EditorPluginAIConfigItemFactory = (options) => ({
	key: CONFIG_ITEM_KEYS.SUMMARISE_WRITING,
	title: aiConfigItemMessages.summarizeWritingtitle,
	description: aiConfigItemMessages.summarizeWritingDescription,
	icon: () => <SummarizeIcon />,
	showInRefineDropdown: true,
	intentSchemaId: 'summarize_intent_schema.json',
	featureId: 'summarize_writing',
	actions: {
		empty: [createInsertAtCurrentPosition({ appearance: 'primary' })],
		selection: [
			createInsertBelow({ appearance: 'secondary', factoryOptions: options }),
			createReplace({ appearance: 'primary' }),
		],
	},
	getBackendModel: () => {
		return 'assistance-service';
	},
});

export const summarizeWritingWithOptions: EditorPluginAIConfigItemWithOptionsFactory = (
	options,
) => ({
	config: summarizeWriting(options),
	triggers: { empty: { enabled: true, docMinSize: 1 }, selection: { enabled: true } },
});

export const summarizeWritingWithOptionsForAtlas: EditorPluginAIConfigItemWithOptionsFactory = (
	options,
) => ({
	config: {
		...summarizeWriting(options),
		description: aiMessages.atlasSummarizePageConfigItemDescription,
	},
	triggers: { empty: { enabled: true, docMinSize: 1 }, selection: { enabled: false } },
});
